import en, { TranslationResource } from './en';
import es from './es';
import { SUPPORTED_LANG } from '../Constants/constants';

// Create a typed resources object
const resources: Record<string, TranslationResource> = {
  [SUPPORTED_LANG.EN]: en,
  [SUPPORTED_LANG.ES]: es
};

export default resources; 